(function() {
  let confettiReady = false;
  function loadConfetti(cb) {
    if (window.confetti) { confettiReady = true; return cb(); }
    if (confettiReady) return cb();
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.2/dist/confetti.browser.min.js';
    s.onload = () => { confettiReady = true; cb(); };
    s.onerror = () => cb();
    document.head.appendChild(s);
  }

  function fireConfetti() {
    if (!window.confetti) return;
    window.confetti({
      particleCount: 60,
      spread: 70,
      origin: { y: 0.65 },
      colors: ['#C8102E', '#F2C500', '#00A36C', '#0A0A0A'],
      ticks: 100,
      gravity: 0.85
    });
  }

  function getCartTarget() {
    const cart =
      document.querySelector('[data-cart-icon]') ||
      document.querySelector('.cart-link') ||
      document.querySelector('a[href$="/cart"]');
    if (!cart) return null;
    const r = cart.getBoundingClientRect();
    return { el: cart, x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function dropLoot(productData) {
    const tpl = document.getElementById('loot-drop-tpl');
    if (!tpl) return;
    const target = getCartTarget();
    if (!target) return;

    const node = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(node);

    node.querySelector('.loot-drop__img').src = productData.image || '';
    node.querySelector('.loot-drop__title').textContent = productData.title || 'In den Korb';
    node.querySelector('.loot-drop__badges').textContent = (productData.badges || []).slice(0, 2).join(' · ');

    // Berechne Translate-Distanz zum Cart-Icon
    const startX = window.innerWidth / 2;
    const startY = window.innerHeight * 0.3;
    const dx = target.x - startX;
    const dy = target.y - startY;
    node.style.setProperty('--target-x', `calc(-50% + ${dx}px)`);
    node.style.setProperty('--target-y', `calc(-50% + ${dy}px)`);

    requestAnimationFrame(() => {
      node.classList.add('is-active');
      requestAnimationFrame(() => node.classList.add('is-flying'));
    });

    setTimeout(() => {
      target.el.classList.add('is-pulsing');
      setTimeout(() => target.el.classList.remove('is-pulsing'), 420);
    }, 700);

    setTimeout(() => node.remove(), 1000);

    loadConfetti(() => setTimeout(fireConfetti, 200));
  }

  function extractProductData(form) {
    const productCard = form.closest('product-card, .product-card, [data-product-card]');
    const img =
      (productCard && productCard.querySelector('img'))?.src ||
      document.querySelector('.product__media img, .product-single__photo img')?.src ||
      '';
    const title =
      form.dataset.productTitle ||
      productCard?.querySelector('.product-card__title, .product__title')?.textContent?.trim() ||
      document.querySelector('.product__title, .product-single__title')?.textContent?.trim() ||
      'Produkt';
    const badges = (form.dataset.productBadges || '').split(',').filter(Boolean);
    return { image: img, title, badges };
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const data = extractProductData(form);
    dropLoot(data);
  }, true);

  // Hook für theme-internal AJAX-Add-Events
  document.addEventListener('cart:item-added', (e) => {
    const detail = e.detail || {};
    dropLoot({
      image: detail.image || '',
      title: detail.title || 'In den Korb',
      badges: detail.badges || []
    });
  });
})();
